import { render, staticRenderFns } from "./BsiMetaDataUpdateFormDetails.vue?vue&type=template&id=6adf76e0&scoped=true&"
import script from "./BsiMetaDataUpdateFormDetails.vue?vue&type=script&lang=js&"
export * from "./BsiMetaDataUpdateFormDetails.vue?vue&type=script&lang=js&"
import style0 from "./BsiMetaDataUpdateFormDetails.vue?vue&type=style&index=0&id=6adf76e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6adf76e0",
  null
  
)

export default component.exports